import { ProtectedJsonAPI } from '.'

export const Currencies = ProtectedJsonAPI.extend(
  '/currencies',
  {
    index:   endpoint => endpoint
  }
)